import { ref, provide, watch, nextTick } from "vue";
import ActionSheep from "../ActionSheep.vue.mjs";
import SvgIcon from "../SvgIcon.vue.mjs";
import ArrowStrokeSelectDownIcon from "../../icons/ArrowStrokeSelectDownIcon.vue.mjs";
/* empty css               */
import normalizeComponent from "../../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {
  __name: "SelectH5",
  props: {
    value: {
      type: [String, Number, Date]
    }
  },
  emits: ["change", "input"],
  setup(__props, { emit }) {
    const props = __props;
    const selectedLabel = ref("");
    const selectedRef = ref();
    const options = ref([]);
    const drawerShow = ref(false);
    const toggleDrawer = async () => {
      drawerShow.value = !drawerShow.value;
      await nextTick();
      if (drawerShow.value) {
        await nextTick();
        await selectedRef.value.scrollIntoView({ block: "center" });
      }
    };
    const onChange = (value) => {
      emit("change", value);
      emit("input", value);
    };
    const updateSelectedLabel = (newValue) => {
      const index = options.value.findIndex((option) => option.value === newValue);
      const matchedOption = options.value[index];
      if (matchedOption && matchedOption.label !== selectedLabel.value) {
        selectedLabel.value = matchedOption.label;
        selectedRef.value = matchedOption.ref;
      }
    };
    const addOption = (option) => {
      const index = options.value.findIndex((item) => item.value === option.value);
      if (index >= 0) {
        options.value[index] = option;
        updateSelectedLabel(props.value);
        return;
      }
      options.value.push(option);
      updateSelectedLabel(props.value);
    };
    const handleOptionClick = (value) => {
      updateSelectedLabel(value);
      onChange(value);
      toggleDrawer();
    };
    provide("TSelect", {
      value: props.value,
      label: selectedLabel,
      addOption,
      handleOptionClick
    });
    watch(
      () => props.value,
      (newValue, oldValue) => {
        if (newValue === oldValue) return;
        updateSelectedLabel(newValue);
      },
      { immediate: true }
    );
    return { __sfc: true, props, emit, selectedLabel, selectedRef, options, drawerShow, toggleDrawer, onChange, updateSelectedLabel, addOption, handleOptionClick, ActionSheep, SvgIcon, ArrowStrokeSelectDownIcon };
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", [_c("div", _vm._b({ staticClass: "custom-select", on: { "change": function($event) {
    return _setup.onChange($event.target.value);
  }, "click": _setup.toggleDrawer } }, "div", _vm.$attrs, false), [_c("span", { staticClass: "label" }, [_vm._v(" " + _vm._s(_setup.selectedLabel || _setup.props.value))]), _c(_setup.SvgIcon, { staticClass: "icon-arrow", attrs: { "icon": _setup.ArrowStrokeSelectDownIcon } })], 1), _c(_setup.ActionSheep, { attrs: { "visible": _setup.drawerShow }, on: { "input": function($event) {
    _setup.drawerShow = $event;
  } } }, [_c("div", { staticClass: "custom-option-container" }, [_vm._t("default")], 2)])], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "79ae4708"
);
const SelectH5 = __component__.exports;
export {
  SelectH5 as default
};
